import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { CallOutError } from "components/CallOutError/CallOutError";

export const PageTool404 = () => {
  return (
    <EuiPageTemplate>
      <CallOutError
        message="The tool you are trying to access does not exist or you do not have
          access to it."
        suppressContactSupport
      />
    </EuiPageTemplate>
  );
};
